import axios from '../../app/api/axios';
import {GET_ERRORS} from '../Errors/types';
import {
    GET_EVENT,
    EVENT_LOADING,
    GET_EVENTS,
    EVENTS_LOADING,
    GET_EVENTS_PUBLICS,
    GET_EVENTS_TYPES,
    TAXONOMIES_LOADING,
    SET_EVENTS_SEARCH_CRITERIA,
    RESET_EVENTS_SEARCH_CRITERIA,
    SIGNUP_TO_EVENT,
    SIGNOUT_FROM_EVENT,
    SIGNUPOROUT_TO_EVENT_LOADING,
    SIGNUPOROUT_TO_EVENT_FAILURE,
    DASHBOARD_GET_EVENTS_CHECKEDIN,
    DASHBOARD_GET_EVENTS_AUTHOR,
    DASHBOARD_GET_EVENTS_LOADING,
    SET_CURRENT_USER_SUBSCRIBED,
    TOGGLE_DIALOG_SUBSCRIBE,
    TOGGLE_DIALOG_SUBSCRIBE_SUCCESS,
    TOGGLE_DIALOG_UNSUBSCRIBE,
    TOGGLE_DIALOG_UNSUBSCRIBE_SUCCESS,
    TOGGLE_DIALOG_UPDATE_SUBSCRIBE,
    TOGGLE_DIALOG_UPDATE_SUBSCRIBE_SUCCESS,
    UI_REMEMBER_SCROLL_POSITION_LISTING,
    UI_REMEMBER_PAGINATION_LISTING,
} from "./types"

/**
 * Get a list of events.
 *
 * @param {number} page                     Pagination
 * @param {boolean} pageWithPreviousResults If false, returns only the results for the given requested page. If true, returns the results for the previous page and the requested page.
 * @param newSearch
 * @param taxoPublic
 * @param taxoType
 * @returns {Function}
 */
export const getEvents = (page = 1, pageWithPreviousResults = false, newSearch = false, taxoPublic = '', taxoType = '') => dispatch => {
    dispatch(setEventsLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('agep/v1/events', {
            page: page,
            pageWithPreviousResults: pageWithPreviousResults,
            public: taxoPublic,
            type: taxoType,
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: GET_EVENTS,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime,
                    search: {
                        public: taxoPublic,
                        type: taxoType,
                    }
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: GET_EVENTS,
                payload: null
            })
        );
};

export const getEvent = (slug) => dispatch => {
    dispatch(setEventLoading());

    axios
        .get('agep/v1/event/' + slug)
        .then(res =>
            dispatch({
                type: GET_EVENT,
                payload: res.data
            })
        )
        .catch(function (err) {
            let redirect = '';

            if (err.response.status === 303 && err.response.data.hasOwnProperty('redirect')) {
                redirect = err.response.data.redirect;
            }

            dispatch({
                type: GET_EVENT,
                payload: null
            });
            dispatch({
                type: GET_ERRORS,
                payload: {
                    status: err.response.status,
                    redirect: redirect,
                }
            });
        });
};

export const getEventsPublics = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    axios
        .get('agep/v1/events/taxonomy/public')
        .then(res =>
            dispatch({
                type: GET_EVENTS_PUBLICS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_EVENTS_PUBLICS,
                payload: null
            })
        );
};

export const getEventsTypes = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    axios
        .get('agep/v1/events/taxonomy/type')
        .then(res =>
            dispatch({
                type: GET_EVENTS_TYPES,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_EVENTS_TYPES,
                payload: null
            })
        );
};

export const setEventsSearchCriteria = (taxoPublic = '', taxoType = '') => dispatch => {
    dispatch({
        type: SET_EVENTS_SEARCH_CRITERIA,
        searchTaxonomyPublic: taxoPublic,
        searchTaxonomyType: taxoType,
    })
};

export const resetEventsSearchCriteria = (taxoPublic = '', taxoType = '') => dispatch => {
    dispatch({
        type: RESET_EVENTS_SEARCH_CRITERIA,
        searchTaxonomyPublic: taxoPublic,
        searchTaxonomyType: taxoType,
    })
};

export const signupToEvent = (slug, data) => dispatch => {
    dispatch(setSignupoutLoading());

    axios
        .post('agep/v1/event/' + slug + '/signup', data)
        .then(res =>
            dispatch({
                type: SIGNUP_TO_EVENT,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SIGNUPOROUT_TO_EVENT_FAILURE,
                payload: err.response.data
            })
        );
};

export const signoutToEvent = (event) => dispatch => {
    dispatch(setSignupoutLoading());

    axios
        .delete('agep/v1/event/' + event.slug + '/signup', {data: event.currentUserCheckinDetails})
        .then(res =>
            dispatch({
                type: SIGNOUT_FROM_EVENT,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SIGNUPOROUT_TO_EVENT_FAILURE,
                payload: err.response.data
            })
        );
};

export const updateSignupToEvent = (slug, data) => dispatch => {
    dispatch(setSignupoutLoading());

    axios
        .post('agep/v1/event/' + slug + '/signup_update', data)
        .then(res =>
            dispatch({
                type: SIGNUP_TO_EVENT,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SIGNUPOROUT_TO_EVENT_FAILURE,
                payload: err.response.data
            })
        );
};

export const dashboardGetEventsCheckedin = (page = 1, newSearch = false) => dispatch => {
    dispatch(setDashboardEventsLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('agep/v1/events_user_checkedin', {
            page: page
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: DASHBOARD_GET_EVENTS_CHECKEDIN,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: DASHBOARD_GET_EVENTS_CHECKEDIN,
                payload: null
            })
        );
};

export const dashboardGetEventsAuthor = (page = 1, newSearch = false) => dispatch => {
    dispatch(setDashboardEventsLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('agep/v1/events_user_author', {
            page: page
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: DASHBOARD_GET_EVENTS_AUTHOR,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: DASHBOARD_GET_EVENTS_AUTHOR,
                payload: null
            })
        );
};

export const setCurrentUserSubscribed = (subscribed) => dispatch => {
    dispatch({
        type: SET_CURRENT_USER_SUBSCRIBED,
        payload: subscribed,
    })
};

export const toggleDialogSubscribe = () => dispatch => {
    dispatch({
        type: TOGGLE_DIALOG_SUBSCRIBE
    })
};

export const toggleDialogUnsubscribe = () => dispatch => {
    dispatch({
        type: TOGGLE_DIALOG_UNSUBSCRIBE
    })
};

export const toggleDialogUpdateSubscribe = () => dispatch => {
    dispatch({
        type: TOGGLE_DIALOG_UPDATE_SUBSCRIBE
    })
};

export const toggleDialogSubscribeSuccess = () => dispatch => {
    dispatch({
        type: TOGGLE_DIALOG_SUBSCRIBE_SUCCESS
    })
};

export const toggleDialogUnsubscribeSuccess = () => dispatch => {
    dispatch({
        type: TOGGLE_DIALOG_UNSUBSCRIBE_SUCCESS
    })
};

export const toggleDialogUpdateSubscribeSuccess = () => dispatch => {
    dispatch({
        type: TOGGLE_DIALOG_UPDATE_SUBSCRIBE_SUCCESS
    })
};

export const setDashboardEventsLoading = () => {
    return {
        type: DASHBOARD_GET_EVENTS_LOADING
    };
};

export const setSignupoutLoading = () => {
    return {
        type: SIGNUPOROUT_TO_EVENT_LOADING
    };
};

export const setEventLoading = () => {
    return {
        type: EVENT_LOADING
    };
};

export const setEventsLoading = () => {
    return {
        type: EVENTS_LOADING
    };
};

export const setTaxonomiesLoading = () => {
    return {
        type: TAXONOMIES_LOADING
    };
};

export const rememberScrollPositionListing = position => {
    return {
        type: UI_REMEMBER_SCROLL_POSITION_LISTING,
        payload: position,
    };
};

export const rememberPaginationListing = page => {
    return {
        type: UI_REMEMBER_PAGINATION_LISTING,
        payload: page,
    };
};



// WEBPACK FOOTER //
// ./src/features/Events/actions.js